<template>
  <Title :text="openSourceLabel" />
  <section class="os-section" v-for="(project, index) in openSourceProjects" :key="index">
    <div class="os-title-row">
      <Headline :text="project.name" />
      <a :href="project.repo" target="_blank" class="os-badge">GitHub ↗</a>
    </div>
    <Paragraph class="text-bold" :text="project.role" />
    <Paragraph class="description" :text="project.description" />
    <div class="os-tags">
      <span class="tag" v-for="tag in project.tags" :key="tag">{{ tag }}</span>
    </div>
  </section>
</template>

<script>
import Title from "@/components/Title.vue";
import Headline from "@/components/Headline.vue";
import Paragraph from "@/components/Paragraph.vue";

export default {
  name: "OpenSource",
  components: { Title, Headline, Paragraph },
  computed: {
    currentLanguage() {
      return this.$store.state.currentLanguage;
    },
    openSourceLabel() {
      return this.currentLanguage.resumeLabels.openSource;
    },
    openSourceProjects() {
      return this.currentLanguage.data.openSource;
    },
  },
};
</script>

<style scoped>
.os-section {
  margin-bottom: 1.5em;
  padding-bottom: 1em;
  border-bottom: 1px solid rgba(79, 70, 229, 0.25);
}
.os-section:last-child {
  margin-bottom: 0;
}
.os-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.os-badge {
  font-size: 11px;
  font-weight: 600;
  color: #4f46e5;
  text-decoration: none;
  white-space: nowrap;
}
.os-badge:hover {
  text-decoration: underline;
}
.text-bold {
  font-weight: bold;
}
.description {
  font-size: 14px;
}
.os-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}
.tag {
  font-size: 11px;
  background: #374151;
  color: #e5e7eb;
  border-radius: 4px;
  padding: 1px 6px;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
</style>
